module.exports = __webpack_public_path__ + "img/purpose_4.455455e6.png";